import '../styles/_loadingPage.scss';

export default function LoadingPage() {
    return (
        <div className="loading">
            <p>
                Sebil Alagoz <span>- Portfolio</span>
            </p>
        </div>
    );
}
